// Spark / INDEX - главная: спонсорские блоки (слайдеры billboard/hero,
// карусели azrow/crow, тултип-дисклоужер) + ротация showcase.
// Stories/Benefits заедут при переносе п.9-10.
import { initSpotlightSliders, initSpotlightCarousels, initSpotlightTips } from './includes/spotlight';
import { initShelfCarousels, initGridDrag, initBrowseCarousel } from './includes/shelf';
import { initHeroSlider } from './includes/heroslider';

document.addEventListener( 'DOMContentLoaded', () => {
    initHeroSlider();
    initSpotlightSliders();
    initSpotlightCarousels();
    initSpotlightTips();
    initShelfCarousels();
    initGridDrag();
    initBrowseCarousel();
} );

// showcase: ротация боковин с отзывами (автоплей 4с, клик по дотам)
document.addEventListener( 'DOMContentLoaded', () => {

    const left  = document.querySelectorAll('#scLeft .showcase-side-img');
    const right = document.querySelectorAll('#scRight .showcase-side-img');
    const dots  = document.querySelectorAll('#scDots .showcase-dot');

    if( ! left.length )
        return;

    let idx   = 0;
    let timer = null;

    function go( n ) {
        idx = n;
        left.forEach( ( slide, i ) => {
            slide.classList.toggle( 'active', i === n );
        } );
        right.forEach( ( slide, i ) => {
            slide.classList.toggle( 'active', i === n );
        } );
        dots.forEach( ( dot, i ) => {
            dot.classList.toggle( 'active', i === n );
        } );
    }

    function play() {
        clearInterval( timer );
        timer = setInterval( () => { go( ( idx + 1 ) % left.length ); }, 4000 );
    }

    dots.forEach( ( dot ) => {
        dot.addEventListener( 'click', () => {
            go( parseInt( dot.dataset.sc, 10 ) );
            play();
        } );
    } );

    play();
} );

// benefits: scroll-reveal фото (макетный IntersectionObserver)
document.addEventListener( 'DOMContentLoaded', () => {

    const visual = document.querySelector('.benefits-visual');

    if( ! visual )
        return;

    const io = new IntersectionObserver( ( [ entry ] ) => {
        visual.classList.toggle( 'in-view', entry.isIntersecting );
    }, { threshold : 0.3 } );

    io.observe( visual );
} );